export default "__VITE_ASSET__0ig8Iey7__"